import { ApplicationModes } from '../../../common/constants/application-modes';
import { PrimaryProductKeys } from '../../../common/constants/primary-product-keys';
import { type PrimaryProductKey } from '../../../common/constants/product-keys';
import { servePromptOfTheDayExperiment } from '../../../common/utils/experiments';

// Initial rollout is Jira and Confluence only; widen this set to add a product.
const ELIGIBLE_PRIMARY_PRODUCTS: ReadonlySet<string> = new Set([
	PrimaryProductKeys.Confluence,
	PrimaryProductKeys.Jira,
]);

// Rovo chat is where the prompt is sent, so the row only exists in Rovo mode.
export const isPromptOfTheDayEligible = (
	applicationMode: ApplicationModes | undefined,
	primaryProduct: PrimaryProductKey | undefined,
): boolean =>
	applicationMode === ApplicationModes.Rovo &&
	primaryProduct !== undefined &&
	ELIGIBLE_PRIMARY_PRODUCTS.has(primaryProduct);

// Reads the experiment value without exposure; usePromptOfTheDayExposure fires it from the pre-query list.
export const isPromptOfTheDayEnabled = (
	applicationMode: ApplicationModes | undefined,
	primaryProduct: PrimaryProductKey | undefined,
): boolean =>
	isPromptOfTheDayEligible(applicationMode, primaryProduct) && servePromptOfTheDayExperiment();
